<template>
  <el-dialog :title="dialogTitle" :visible="visible" width="960px" top="8vh" append-to-body :destroy-on-close="true"
    :lock-scroll="false" @update:visible="updateVisible" @opened="handleOpened">
    <ele-pro-table ref="table" :where="where" :datasource="url" :columns="columns" height="420px">
      <template slot="roles" slot-scope="{ row }">
        <el-tag v-for="item in row.roles" :key="item.id" size="mini" type="primary" :disable-transitions="true">
          {{ item.name }}
        </el-tag>
      </template>
      <template slot="status" slot-scope="{ row }">
        <dict-tag dict-code="common_status" :value="row.status" />
      </template>
    </ele-pro-table>
    <div slot="footer">
      <el-button @click="updateVisible(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'TenantAdminStaffListDialog',
  props: {
    visible: Boolean,
    tenantAdmin: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      url: '/tenantadmin/staffList',
      where: {},
      columns: [
        {
          prop: 'id',
          label: '序号',
          width: 60,
          align: 'center',
          showOverflowTooltip: true
        },
        {
          prop: 'username',
          label: '账号',
          align: 'center',
          showOverflowTooltip: true,
          minWidth: 100
        },
        {
          prop: 'mobile',
          label: '手机',
          align: 'center',
          showOverflowTooltip: true,
          minWidth: 100
        },
        {
          prop: 'email',
          label: '邮箱',
          align: 'center',
          showOverflowTooltip: true,
          minWidth: 110
        },
        {
          prop: 'login_ip',
          label: 'IP地址',
          align: 'center',
          showOverflowTooltip: true,
          minWidth: 110
        },
        {
          columnKey: 'roles',
          label: '角色',
          align: 'center',
          showOverflowTooltip: true,
          minWidth: 100,
          slot: 'roles'
        },
        {
          columnKey: 'status',
          prop: 'status',
          label: '状态',
          align: 'center',
          width: 80,
          slot: 'status'
        },
        {
          prop: 'create_user_name',
          label: '创建者',
          align: 'center',
          showOverflowTooltip: true,
          minWidth: 120
        },
        {
          prop: 'create_time',
          label: '创建时间',
          align: 'center',
          showOverflowTooltip: true,
          minWidth: 140,
          formatter: (row, column, cellValue) => this.$util.toDateString(cellValue)
        }
      ]
    };
  },
  computed: {
    dialogTitle() {
      if (!this.tenantAdmin) {
        return '子账号列表';
      }
      const name = this.tenantAdmin.tenant_name;
      const username = this.tenantAdmin.username;
      if (name && username) {
        return `子账号列表 - ${name}（${username}）`;
      }
      return username ? `子账号列表 - ${username}` : '子账号列表';
    }
  },
  methods: {
    updateVisible(val) {
      this.$emit('update:visible', val);
    },
    handleOpened() {
      const id = this.tenantAdmin && this.tenantAdmin.id;
      this.where = id ? { tenant_admin_id: id } : {};
      this.$nextTick(() => {
        if (this.$refs.table) {
          this.$refs.table.reload({ page: 1, where: this.where });
        }
      });
    }
  }
};
</script>
